<template>
    <side-bar icon="movie_edit" title="Select event" search :search-loading="loading" v-model="search_text">
      <template #default>
        <div>
          <div v-for="info in grouped_events" :key="info.timestamp" class="day-group">
            <div class="day-header">{{info.timestamp | format_date}}</div>

            <k-list bordered :items="sorted(info.events)" :url="event_url">
              <template #default="{ item: event}">{{title(event)}}</template>
              <template #subtitle="{ item: event}">{{subtitle(event)}}</template>
              <template #left="{ item: event}">
                <div style="display: grid; grid-template-columns: 25px 1fr;">
                  <div style="tex-align: left">
                    <k-icon small :color="icon_color(event)" >circle</k-icon>
                  </div>
                  <div style="line-height: initial;">
                    <span>{{event.cached_start_time | format_time}}</span><br/>
                    <span style="color: var(--ks-font-color-secondary)">{{event.cached_end_time | format_time}}</span>
                  </div>
                </div>
              </template>
            </k-list>
          </div>
          <k-btn @click="load_next" :loading="loading" v-if="show_button" v-observe-visibility="{callback: visibility_changed, once: false}">Load next {{page_size}}</k-btn>
        </div>
      </template>
    </side-bar>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import strftime from 'strftime';
import EventSearch from '../dashboard/Search'
import Vue from 'vue';
import SideBar from '@/components/SideBar.vue'

import CloudRecEvent from './Event.vue'
import EventModel from '@/models/event.js'

export default {
  props: {
    "issearch": {
      type: Boolean,
      default: true
    },
    "start": Number,
    "end": Number
  },
  filters: {
    ...datelib
  },
  components: {
    CloudRecEvent,
    EventSearch,
    SideBar
  },
  data () {
  	var start_date = moment(0).startOf('day').toDate();
	  var end_date = moment().endOf('day').toDate();
    return {
      event_search: "",
      show_button: false,
      loading: false,
      search_text: "",
      search_menu: false,
    	headers: [],
      channel: undefined,
      events: [],
      page_size: 50,
      grouped_events: [],
      events_by_uuid: {},
      filters: {
        daterange: {
          start: start_date,
          end: end_date
        },
        states: ["active"],
        offset: 0
      },
  	}
  },
  watch: {
    search_text (new_val, old_val) {
      clearTimeout(this.search_timer);
      if (new_val != old_val && !new_val) {
        this.search_pending = false;
        this.events_by_uuid = {};
        this.filters.offset = 0;
        this.filterEvents();
        return;
      }
      this.search_pending = true;
      this.search_timer = setTimeout(() => {
        this.search_pending = false;
        this.filters.offset = 0;
        this.filterEvents();
      }, 400);
    }
  },
  computed: {
    is_search () {
      return (this.search_text != null && this.search_text.length > 2);
    },
    event_count () {
      return Object.values(this.events_by_uuid).length;
    }
  },
  mounted: function() {
  	this.connect_ws();
    var self = this;
  },
  beforeDestroy () {
    clearTimeout(this.search_timer);
  },
  methods: {
    event_url(event) {
      return this.$router.resolve("/cloudrec/event/"+event.uuid+"?start="+this.start+"&end="+this.end).href;
    },
    title(event) {
      return EventModel.title(event);
    },
    subtitle(event) {
      return EventModel.subtitle(event);
    },
    visibility_changed (newVal) {
      if (newVal == true) {
        this.load_next();
      }
    },
    icon_color(event) {
      if (this.is_current(event)) {
        return "success"
      }
      if (this.is_past(event)) {
        return "primary";
      }
      return "grey";
    },
    is_current(event) {
      return EventModel.is_current(event);
    },
    is_past(event) {
      return EventModel.is_past(event);
    },
    get_grouped_events: function(events) {
      var self = this;
      var ret = {};

      var filtered_events = events;

      if (this.$is_admin()) {
        filtered_events = _.filter(filtered_events, function(event) {
          var ch = EventModel.output_channel(event);
          if (typeof(ch) == "undefined") return true; // Ei löydy kanavaa, ei filtteröidä pois
          if (typeof(ch.configuration.clip) != "undefined") return true;
          return false;
        }); 
      }

      _.each(filtered_events, function(event) {
        var d = moment(event.cached_start_time * 1000).startOf('day').unix();
        if (typeof(ret[d]) == "undefined") ret[d] = [];
        ret[d].push(event);
      });

			ret = _.map(ret, function(data, idx) {
  			return {timestamp: idx, events: data};
  		});
  		ret = _.sortBy(ret, ["timestamp"]);

      return ret.reverse();
    },
    open_add_event () {
      this.$router.push("/dashboard/event_new");
    },
  	format_date (date) {
  		if (date == moment().startOf('day').unix()) return "Today";
  		return datelib.format_date(date);
  	},
  	sorted(list) {
  		return _.sortBy(list, [function(o) { return o.cached_start_time}, "uuid"]).reverse();
  	},
  	filterEvents () {
      var self = this;
      var _filters = _.cloneDeep(this.filters);

      if (this.is_search) {
        _filters.search = this.search_text;
      }
      if(typeof(_filters.daterange.start) != "undefined") {
        _filters.daterange.start = moment(_filters.daterange.start).startOf('day').unix();
      }
      _filters.daterange.end = this.is_search ? moment().endOf('day').unix() : moment(_filters.daterange.end).endOf('day').unix();
      _filters.limit = this.page_size;
      _filters.order_by = [{"cached_start_time":"desc"}, {"uuid": "desc"}];
      console.log("PUSHING FILTER REPLY");
      // Reply is stale only if a newer offset-0 query has been issued since
      var generation = _filters.offset == 0 ? this.generation = (this.generation || 0) + 1 : this.generation;
      this.loading = true;
      this.channel.push("filter_reply", _filters)
        .receive("ok", (msg) => {
          if (generation !== self.generation) return;
          self.loading = false;
          console.log("filter reply received");
          if (_filters.offset == 0) {
            self.events_by_uuid = {};
          }
          _.each(msg.events, function(event) {
            self.add_event_to_list(event);
          });
          self.show_button = msg.events.length >= self.page_size;

          Vue.nextTick(function () {
            self.grouped_events = self.get_grouped_events(Object.values(self.events_by_uuid));
            if (_filters.offset == 0) self.scroll_to_top();
          });
        })
        .receive("error", (msg) => {
          if (generation === self.generation) self.loading = false;
          console.log("Event filter failed");
        })
        .receive("timeout", () => {
          if (generation === self.generation) self.loading = false;
        });
//      this.channel.push("filter", _filters);
    },
    scroll_to_top() {
      var body = this.$el && this.$el.querySelector(".ks-panel-body");
      if (body) body.scrollTop = 0;
    },
    is_between_dates(event) {
      var _filters = _.cloneDeep(this.filters);
      var start_date = moment(_filters.daterange.start).startOf('day').unix();
      var end_date = this.is_search ? moment().endOf('day').unix() : moment(_filters.daterange.end).endOf('day').unix();
      return (event.cached_end_time > start_date && event.cached_start_time < end_date);
    },
    add_event_to_list(event) {
      var self = this;
      if (event.state == "active" && self.is_between_dates(event) ) {
        Vue.set(self.events_by_uuid, event.uuid, event);
      } else {
        Vue.delete(self.events_by_uuid, event.uuid);
      }
    },
    load_next() {
      if (this.loading || this.search_pending) return;
      this.filters.offset = this.filters.offset + this.page_size;
      console.log("Loading next", this.filters.offset);
      this.filterEvents();
    },
  	connect_ws () {
  		var self = this;
	    this.channel = this.$cloudserver.channel("events:all");
  	  this.channel.on("init", function(msg) {
      	self.filters.offset = 0;
      	self.filterEvents();
    	});

    	this.channel.on("event-update", function(msg) {

        var event = msg.data;
        if (!self.events_by_uuid[event.uuid]) return;
        self.add_event_to_list(event);

        Vue.nextTick(function () {
          self.grouped_events = self.get_grouped_events(Object.values(self.events_by_uuid));
        });
    	});
    	// Shared channel is already joined (e.g. from dashboard): "init" won't fire again
    	if (!this.channel.join()) {
    	  this.filterEvents();
    	}
  	}
  }


}
</script>

<style scoped>
.day-group {
  margin-top: 30px;
}
.day-header {
  position: sticky;
  top: 0;
  z-index: var(--ks-z-sticky, 1);
  margin-bottom: 8px;
  padding: 8px 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--ks-font-color-primary);
  background: var(--ks-background-color-light);
  border-left: 4px solid var(--ks-col-accent);
  border-bottom: 1px solid var(--ks-col-secondary);
  border-radius: 4px;
}
</style>